//React components
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
//Components
import Navbar from '../NavBar/Navbar';
import TransactionHistory from "../transactions/TransactionHistory";
import LoadingAlert from '../Alerts/LoadingAlert';
import SuccessAlert from '../Alerts/SuccessAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import Modal from 'react-bootstrap/Modal';
//Internal components
import ReportTable from '../reports/table/ReportTable';
import OrderDetails from '../Orders/OrderDetails';
//External modules
import moment from 'moment-timezone';
import ModalBranchofficeSelect from '../NavBar/ReportModalBranchofficeSelect';
//API
import { OrdersFetchAPI } from '../../api/Orders';
import { checkUserPermission } from '../utils/CheckUserPermitions';
//img
import empty from '../img/icons/empty.png'
import totals from '../img/icons/total.png'
//Utils
import { RenderIf } from '../utils/RenderIf';
//CSS
import './analitics.css'
import AppShell from '../../page/AppShell/AppShell';
import MainContent from '../MainContent/MainContent';

/* ── ICONS ── */
const IcoSearch = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>;
const IcoBuilding = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>;
const IcoReceipt = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></svg>;
const IcoWallet = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="5" width="20" height="14" rx="2" /><path d="M16 12h.01" /></svg>;
const IcoCoins = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="8" cy="8" r="6" /><path d="M18.09 10.37A6 6 0 1 1 10.34 18" /><path d="M7 6h1v4" /><path d="m16.71 13.88.7.71-2.82 2.82" /></svg>;
const IcoCheck = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>;
const IcoArrow = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6" /></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
function AnaliticStore() {

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  let { business_code } = useParams();
  let user = localStorage.getItem('user') !== '' || localStorage.getItem('user') !== undefined
    ? JSON.parse(localStorage.getItem('user')) : '';
  let token = localStorage.getItem('x-access-token');

  const [branchOrdersData, setBranchOrdersData] = useState([]);
  const [branchAnaliticsData, setBranchAnaliticsData] = useState([]);
  const [temporal, setTemporal] = useState([]);
  const [minDate, setMinDate] = useState(new Date().toJSON().slice(0, 10));
  const [userBranchoffices, setUserBranchs] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [ordersPaymentMethod, setOrdersPaymentMethod] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [detailOrderModalShow, setDetailOrderModalShow] = useState(false);
  const [detailOrder, setDetailOrder] = useState();
  const [order_type, setOrderType] = useState("temporal");
  const [reload, setReLoad] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(0);

  const actualDate = moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD');
  const maxDate = actualDate + 'T23:59:59.000+00:00';

  const handleCloseModal = () => { setModalShow(false); setSelectedPaymentMethod(0); };
  const handleShowModal = () => setModalShow(true);
  const handleCloseDetailOrderModal = () => setDetailOrderModalShow(false);
  const handleShowDetailOrderModal = () => setDetailOrderModalShow(true);

  const EmptyCard = () => (
    <div className="as-empty">
      <img src={empty} alt="Vacío" width="60" height="60" />
      <p className="as-empty-title">Sin transacciones</p>
      <p className="as-empty-sub">Selecciona una fecha y presiona Consultar para ver los resultados.</p>
    </div>
  );

  const listOrders = () => {
    const items = branchOrdersData.map((data) => (
      <>
        <div
          onClick={async () => { await getOrderById(data._id); handleShowDetailOrderModal(); }}>
          <TransactionHistory data={data} />
        </div>
      </>
    ));
    if (items.length === 0) return EmptyCard();
    return items;
  };

  const getOrderById = async (order_id) => {
    try {
      const response = await OrdersFetchAPI.getOrderById(order_id, token);
      setDetailOrder(response.data.order); setOrderType("permanent");
    } catch (err) { setDetailOrder({}); setOrderType("permanent"); }
  };

  const detailOrderList = () => {
    return detailOrder === undefined ? "" : (
      <OrderDetails orderData={detailOrder} order_type={order_type} business_data={user.business} setLoad={setReLoad} />
    );
  };

  const getTransactionsByBranchOffice = async (business_code, branches, minDate, maxDate) => {
    try {
      const branchCodes = !branches || branches.length === 0 ? [] : branches.map(b => b.code);
      const response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethodbyUser(
        business_code, 0, minDate, maxDate, 0, user.id, token,
        undefined, undefined, undefined, undefined, undefined, undefined, undefined, branchCodes
      );
      setBranchOrdersData(response.data.orders);
      setTemporal(response.data.orders);
      setBranchAnaliticsData([response.data.analitics]);
    } catch (err) { ErrorAlert('No tiene información'); console.log(err); }
  };

  function handleChangeFiltro(event) {
    let resultFilter = [];
    if (event.target.value == "") {
      console.log(event.target.value); setBranchOrdersData(temporal);
    } else {
      for (let recorrer = 0; recorrer < branchOrdersData.length; recorrer++) {
        const examinar = branchOrdersData[recorrer];
        const info = JSON.stringify(examinar);
        const resultado = info.toLowerCase().includes(event.target.value.toLowerCase());
        if (resultado == true) { resultFilter.push(examinar); setBranchOrdersData(resultFilter); console.log(resultFilter); }
      }
    }
  }

 const CardsCounts = (data) => {
  const getdata = data.filter(item => {
    const permissionKey = `view_total_${item.name.toLowerCase()}`;
    return checkUserPermission(permissionKey, user.permissions) !== -1;
  });
 
  return (
    <div className="st-list">
      {getdata.map((item, i) => {
        const key = item.name.toLowerCase();
        // clase de "marca" para el tile del ícono
        const brand =
          key === 'visa' ? 'is-visa' :
          key === 'mastercard' ? 'is-mc' :
          key === 'amex' ? 'is-amex' :
          key === 'yappy' || key === 'yappy qr' ? 'is-yappy' :
          key === 'clave' ? 'is-clave' :
          key === 'efectivo' ? 'is-cash' :
          key === 'nota de credito' || key === 'credito' ? 'is-credit' :
          key === 'pcccoin' ? 'is-coin' :
          'is-neutral';
 
        return (
          <button
            type="button"
            className={`st-list-row st-list-row--btn card-analitics-sp-sm ${brand}`}
            key={item.paymentmethod_id || i}
            style={{ animationDelay: `${i * 0.04}s` }}
            onClick={() => { setModalShow(true); getPaymentMethodOrders(item.paymentmethod_id); }}
          >
            <span className="st-list-ico">
              <RenderIf isTrue={key === 'visa'}>
                <i className="fa-brands fa-cc-visa" />
              </RenderIf>
              <RenderIf isTrue={key === 'yappy' || key === 'yappy qr'}>
                <i className="fa-solid fa-comments" />
              </RenderIf>
              <RenderIf isTrue={key === 'mastercard'}>
                <i className="fa-brands fa-cc-mastercard" />
              </RenderIf>
              <RenderIf isTrue={key === 'clave'}>
                <i className="fa-solid fa-credit-card" />
              </RenderIf>
              <RenderIf isTrue={key === 'efectivo'}>
                <i className="fa-solid fa-sack-dollar" />
              </RenderIf>
              <RenderIf isTrue={key === 'amex'}>
                <i className="fa-brands fa-cc-amex" />
              </RenderIf>
              <RenderIf isTrue={key === 'nota de credito' || key === 'credito'}>
                <i className="fa-solid fa-clipboard" />
              </RenderIf>
              <RenderIf isTrue={key === 'pcccoin'}>
                <i className="fa-solid fa-ticket" />
              </RenderIf>
            </span>
 
            <div className="st-list-body">
              <span className="st-list-name ">{item.name}</span>
              <span className="st-list-sub">Toca para ver detalle</span>
            </div>
 
            <span className="st-list-value ">
              <span className="st-list-cur">$</span>
              {!item.total ? '0.00' : parseFloat(item.total).toFixed(2)}
            </span>
 
            <span className="st-list-caret" aria-hidden="true">
              <IcoArrow />
            </span>
          </button>
        );
      })}
    </div>
  );
};
 
/* ── branchofficeCards: filas con ícono + nombre + monto ── */
const branchofficeCards = (data) => (
  <div className="st-list">
    {data.map((item, i) => (
      <div
        className="st-list-row is-branch"
        key={item.branchoffice_name || i}
        style={{ animationDelay: `${i * 0.04}s` }}
      >
        <span className="st-list-ico"><IcoBuilding /></span>
        <div className="st-list-body">
          <span className="st-list-name">{item.branchoffice_name}</span>
          <span className="st-list-sub">Sucursal</span>
        </div>
        <span className="st-list-value">
          <span className="st-list-cur">$</span>
          {parseFloat(item.total).toFixed(2)}
        </span>
      </div>
    ))}
  </div>
);

  const getPaymentMethodOrders = async (paymentmethod_id) => {
    try {
      const branchCodes = !selectedBranches || selectedBranches.length === 0
        ? [] : selectedBranches.map(b => b.code);
      const response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethod(
        business_code, branchCodes, minDate, maxDate, paymentmethod_id, token
      );
      setSelectedPaymentMethod(paymentmethod_id);
      setOrdersPaymentMethod(response.data.orders);
    } catch (err) { console.log(err); }
  };

  const reportDetail = (general_sales) => (
    <ReportTable
      table_name="Tabla de ventas detalladas"
      table_headers={["Fecha", "Hora", "Orden", "Metodo de pago", "Total con propina", "Propina", "Total contable", "Subtotal", "Itbms", "Descuento", "Cufe"]}
      table_type="paymentmethod_report"
      table_data={general_sales}
    />
  );

  const viewAnalitics = () => {
    const content = branchAnaliticsData.map((data, idx) => (
      <React.Fragment key={idx}>

        {/* ═══════════════════ KPIs ═══════════════════*/}
        <RenderIf isTrue={checkUserPermission('get_totals', user.permissions) !== -1}>
          <div className="st-kpis">

            {/* Hero — Total cobrado */}
            <div className="st-kpi st-kpi--hero">
              <div className="st-kpi-body">
                <div className="st-kpi-topline">
                  <span className="st-kpi-label">Total cobrado</span>
                  <span className="st-kpi-chip">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                    {minDate || 'Hoy'}
                  </span>
                </div>
                <div className="st-kpi-value">
                  <span className="st-kpi-cur">$</span>
                  {!data.totalSalesWithTips ? '0.00' : parseFloat(data.totalSalesWithTips).toFixed(2)}
                </div>
                <div className="st-kpi-foot">
                  Ventas + propinas del periodo
                </div>
              </div>
              {/* ícono decorativo al fondo derecho */}
              <span className="st-kpi-ghost" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 1v22M17 5H9.5a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H6" />
                </svg>
              </span>
            </div>

            {/* Sub — Total facturado */}
            <div className="st-kpi st-kpi--sub">
              <div className="st-kpi-topline">
                <span className="st-kpi-ico st-kpi-ico--brand">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
                    <rect x="9" y="3" width="6" height="4" rx="1" />
                    <path d="M9 12h6M9 16h4" />
                  </svg>
                </span>
                <span className="st-kpi-label">Total facturado</span>
              </div>
              <div className="st-kpi-value">
                <span className="st-kpi-cur">$</span>
                {!data.totalSales ? '0.00' : parseFloat(data.totalSales).toFixed(2)}
              </div>
              <div className="st-kpi-meta">Ventas netas</div>
            </div>

            {/* Sub — Propinas */}
            <div className="st-kpi st-kpi--sub">
              <div className="st-kpi-topline">
                <span className="st-kpi-ico st-kpi-ico--warn">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="9" /><path d="M12 6v6l3 3" />
                  </svg>
                </span>
                <span className="st-kpi-label">Propinas</span>
              </div>
              <div className="st-kpi-value">
                <span className="st-kpi-cur">$</span>
                {!data.totalTips ? '0.00' : parseFloat(data.totalTips).toFixed(2)}
              </div>
              <div className="st-kpi-meta">Acumuladas</div>
            </div>

          </div>
        </RenderIf>

        {/* ═══════════════════ Paneles ═══════════════════ */}
        <div className="st-panels">

          {/* Métodos de pago */}
          <div className="st-panel">
            <div className="st-panel-head">
              <span className="st-panel-ico"><IcoWallet /></span>
              <span className="st-panel-title">Métodos de pago</span>
              <span className="st-panel-badge">{data.paymenthods?.length || 0}</span>
            </div>
            <div className="st-panel-body main-content">
              {CardsCounts(data.paymenthods)}
            </div>
          </div>

          {/* Sucursales */}
          <RenderIf isTrue={checkUserPermission('get_branch_totals', user.permissions) !== -1}>
            <div className="st-panel">
              <div className="st-panel-head">
                <span className="st-panel-ico"><IcoBuilding /></span>
                <span className="st-panel-title">Sucursales</span>
                <span className="st-panel-badge">{data.branchofficeTotals?.length || 0}</span>
              </div>
              <div className="st-panel-body main-content">
                {branchofficeCards(data.branchofficeTotals)}
              </div>
            </div>
          </RenderIf>

        </div>
      </React.Fragment>
    ));
    return <>{content}</>;
  };

  const actionSelectBranches = (branches) => { setSelectedBranches(branches); };

  useEffect(() => {
    (async () => {
      try {
        setUserBranchs(user.branchoffices);
        //getTransactionsByBranchOffice(business_code, selectedBranch.code, actualDate, maxDate);
      } catch (err) { console.log(err); }
    })();
    setReLoad(0);
  }, [reload]);


  return (
    <>
      <AppShell route="analitics">
        <MainContent>
          <div className="as-page ">
            <div className="as-inner ">


              {/* header Original: Review CSS */}
              <div className="ts-top">
                <div className="ts-top__left">
                  <div>
                    <div className="ts-top__title">Analíticas de ventas</div>
                    <div className="ts-top__sub">Gestión de Analíticas de ventas</div>
                  </div>
                </div>
                <div className="ts-top__right">

                  <div className="pf-bar">

                    <div className="pf-field">
                      <span className="pf-field-ico">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M3 9l1.5-5h15L21 9" />
                          <path d="M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0" />
                          <path d="M4 11v9h16v-9" />
                        </svg>
                      </span>
                      <span className="pf-field-k">Sucursal</span>
                      <ModalBranchofficeSelect actionSelectBranches={actionSelectBranches} />
                    </div>

                    <label className="pf-field" htmlFor="pf-date">
                      <span className="pf-field-ico">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="17" rx="3" />
                          <path d="M8 2v4M16 2v4M3 10h18" />
                        </svg>
                      </span>
                      <span className="pf-field-k">Fecha</span>
                      <input
                        id="pf-date"
                        onChange={e => setMinDate(e.target.value)}
                        type="date" name="date"
                        className="pf-field-input"
                      />
                    </label>



                    <button
                      className="pf-btn"
                      type="button"
                      id="btn-analitycs"
                      onClick={() => getTransactionsByBranchOffice(
                        business_code, selectedBranches, minDate, `${minDate}T23:59:59.000+00:00`
                      )}
                    >
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                      Consultar
                    </button>
                  </div>



                </div>
              </div>
              {/* End header Original: Review CSS */}




              <main className="th-layout">

                {/* KPIs + Métodos + Sucursales (usa las mismas clases as- del CSS actualizado) */}
                <div className="th-analytics">
                  {viewAnalitics()}
                </div>

                {/* Toolbar: título + buscador (como "Order line ... Recent Order | See All") */}
                <div className="th-toolbar">
                  <div className="th-toolbar-title">
                    <span className="th-toolbar-ico">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
                        <rect x="9" y="3" width="6" height="4" rx="1" />
                        <path d="M9 12h6M9 16h4" />
                      </svg>
                    </span>
                    <h2 className="th-toolbar-h">Historial de transacciones</h2>
                  </div>

                  <label className="th-search" htmlFor="th-search-input">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="11" cy="11" r="7" />
                      <path d="M20 20l-3.5-3.5" />
                    </svg>
                    <input
                      id="th-search-input"
                      spellCheck="false"
                      type="text"
                      step="any"
                      onChange={handleChangeFiltro}
                      placeholder="Buscar orden…"
                      className="th-search-input"
                    />
                  </label>
                </div>

                {/** We get the list of the order */}
                <RenderIf isTrue={checkUserPermission("transaction_list", user.permissions) !== -1}>
                  <div className="th-grid">
                    {listOrders()}
                  </div>
                </RenderIf>
              </main>
            </div>
          </div>
        </MainContent>
      </AppShell>

      {/* Modal: reporte detallado — original intacto */}
      <Modal size="xl" show={modalShow} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Detalles</Modal.Title>
        </Modal.Header>
        <Modal.Body>{reportDetail(ordersPaymentMethod)}</Modal.Body>
      </Modal>

      {/* Modal: detalle de orden — original intacto */}
      <Modal size='md-down' show={detailOrderModalShow} onHide={handleCloseDetailOrderModal}>
        <Modal.Header closeButton>
          <Modal.Title>Detalles</Modal.Title>
        </Modal.Header>
        <Modal.Body>{detailOrderList()}</Modal.Body>
      </Modal>

      {void [Navbar, LoadingAlert, SuccessAlert, userBranchoffices, actualDate, maxDate]}
    </>
  );
}

export default AnaliticStore;